<template>
  <div class="uv-card">
    <div class="uv-card-body">
      <h3 class="uv-card-title">Importador de pagos</h3>
      <input type="file" accept=".csv" @change="handleFileUpload($event)" />
      <v-btn v-if="!loading" class="float-right" lg color="red" @click="sendConceptos()" dark
        >Importar</v-btn
      >
      <v-btn v-if="!loading" class="float-right mx-1" lg color="primary" @click="downloadFile()" dark
        >Descargar formato</v-btn
      >
      <v-progress-circular
        v-if="loading"
        class="float-right"
        indeterminate
        color="primary"
      ></v-progress-circular>
      <v-alert
        class="mt-2"
        v-if="success == true"
        type="success"
      >Importado correctamente</v-alert>
      <v-alert
      class="mt-2"
        v-if="success == false"
        type="error"
      >Ocurrio un error al importar : {{error}}</v-alert>
    </div>
    <v-card v-if="parsed">
      <v-card-text>
        <v-simple-table>
          <thead>
            <tr>
              <th width="10%" class="text-left">Fecha</th>
              <th width="10%" class="text-left">Folio</th>
              <th class="text-left">Cliente</th>
              <th class="text-left">Membresia</th>
              <th class="text-left">Metodo Pago</th>
              <th class="text-left">Cantidad</th>
              <th class="text-left">Moneda</th>
              <th class="text-left">Concepto</th>
              <th class="text-left">Periodo</th>
              <th class="text-left">Transacción</th>
              <th class="text-left">Estatus</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in content" :key="index">
              <td>{{ item.Fecha }}</td>
              <td>{{ item.Folio }}</td>
              <td>
                <v-autocomplete
                  @change="onSelect(index)"
                  v-model="item.idMembresia"
                  item-text="text"
                  item-value="Id"
                  :items="dataMembresias"
                ></v-autocomplete>
              </td>
              <td>{{ item.Membresia }}</td>
              <td>{{ item.MetodoPago }}</td>
              <td>{{ $pgsHelper.formatNumber(item.Cantidad) }}</td>
              <td>{{ item.Moneda }}</td>
              <td>{{ item.Concepto }}</td>
              <td>{{ item.Periodo }}</td>
              <td>{{ item.Transaccion }}</td>
              <td>
                <b
                  v-bind:class="{
                    'success--text': item.valido,
                    'red--text': !item.valido,
                  }"
                  >{{ item.valido ? "Valido" : "No se puede importar" }}</b
                >
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-card-text>
    </v-card>
  </div>
</template>



<script>
import Papa from "papaparse";
import Membresia from "../../clases/Membresias/Membresia.js";
import MembresiaPlan from "../../clases/Membresias/MembresiaPlan.js";
import PeriodosCobro from "../../clases/Membresias/PeriodosCobro.js";
import firebaseAxios from "../../helpers/firebaseAxios.js";
import FirebaseConfig from "../../helpers/FirebaseConfig.js";

export default {
  name: "importador",
  components: {},
  data() {
    return {
      file: "",
      content: [],
      parsed: false,
      loading: false,
      conceptos: [],
      success:null,
      error:''
    };
  },
  computed: {
    conceptosMemebresia() {
      return [];
    },
    clients() {
      let clientes = {};
      let rowclientes = this.$store.getters.getClientes;
      rowclientes.forEach((element) => {
        if (element.id != "PUBLICOGENERAL") {
          clientes[element.id] = element;
        }
      });
      return clientes;
    },
    dataMembresias() {
      let data_membresias = Membresia.getMembresiasList();
      data_membresias.forEach((element) => {
        element.code = element?.Code?.Pre + "" + element?.Code?.Pos;
        element.NumeroMembresia = element?.Code?.Pos;
        element.PlanName = this.$pgsHelper.getById(
          this.PlanesMembresias,
          "Id",
          element.Plan
        ).Nomb;
        element.TitularName = this.clients[element.Titular]
          ? this.clients[element.Titular].Nombres +
            " " +
            this.clients[element.Titular].Apellidos +
            (this.clients[element.Titular].Apodo &&
            this.clients[element.Titular].Apodo != ""
              ? " (" + this.clients[element.Titular].Apodo + ")"
              : "")
          : "Sin titular";
        element.NombrePeriodo = PeriodosCobro.getById(element.Periodo).Nombre;
        element.Apodo = this.clients[element.Titular]?.Apodo
        element.text =
          element.Code.Pre +
          "" +
          element.Code.Pos +
          " - " +
          element.TitularName;
      });
      return data_membresias;
    },
  },
  methods: {
    downloadFile(){
      location.href='/files/csv-sample.csv';
    },
    async sendConceptos() {
      this.loading =true;
      let data = [];
      this.content.forEach((item) => {
        if (item.valido) {
          data.push({
            fecha: item.Fecha,
            periodo: item.Periodo,
            cliente: { id: item.idCliente, nomb: item.Cliente},
            membresia: item.idMembresia,
            pago: {
              C: Number(item.Cantidad),
              M: item.Moneda,
            },
            moneda: item.Moneda,
            metodoPago:item.MetodoPago,
            folio:item.Folio,
            concepto: {
              id: item.coceptoId,
              dscr: item.conceptoDescr,
              ctgr: item.category,
            },
            transaccion: item.Transaccion,
          });
        }
      });
      console.log(JSON.stringify(data));
      let fba = new firebaseAxios("https://pgs-golfcourse-tasks-dot-pargolfsolutions-e4659.uc.r.appspot.com");
      fba.setTenant(localStorage.getItem('ParGolfTenant'))
      const axs = fba.useCustomUrl("https://pgs-golfcourse-tasks-dot-pargolfsolutions-e4659.uc.r.appspot.com")
      const fireConf =  new FirebaseConfig();
      let dtos = {movimientos:data,tenant:'PCUN',departamento:"CARGASMASIVAS"}
      this.$store.getters.getFirebaseApp.fba.call("MBS-importador-movimientos",dtos )
        .then((result) => {
          console.log(result);
          if(result.data.ok){
            this.success = true
          }else{
            this.success = false
            this.error = result.data.error
          }
          this.loading =false;
        })
        .catch((error) => {
          console.log(error);
          this.error = error.message
          this.success = false
          this.loading =false;
        });
    },
    async getConceptos() {
      const database = this.$store.getters.getFirebaseApp.database;
      const ref = database.ref("MBS/Conceptos");
      const snapshot = await database.get(ref);
      if (!snapshot.exists()) {
        return false;
      }
      this.conceptos = this.$pgsHelper.ArrayObjectToArray(snapshot.val());
    },
    onSelect(index) {
      let mem = this.$pgsHelper.getById(
        this.dataMembresias,
        "Id",
        this.content[index].idMembresia
      );
      let con = this.$pgsHelper.getById(
        this.conceptos,
        "code",
        this.content[index].Concepto
      );
      if (mem) {
        this.content[index].valido = true;
        this.content[index].idMembresia = mem.Id;
        this.content[index].idCliente = mem.Titular;
        this.content[index].Cliente = mem.TitularName;
      }
      if (!con) {
        this.content[index].valido = false;
      }
      this.$forceUpdate();
    },
    handleFileUpload(event) {
      this.file = event.target.files[0];
      this.parseFile();
    },
    parseFile() {
      (this.loading = true),
        Papa.parse(this.file, {
          header: true,
          skipEmptyLines: true,
          complete: function (results) {
            this.content = this.dataParsedOnload(results);
            this.parsed = true;
            this.loading = false;
          }.bind(this),
        });
    },
    dataParsedOnload(content) {
      let csvData = content.data;
      let data = [];
      csvData.forEach((csv) => {
        let mem = this.$pgsHelper.getById(
          this.dataMembresias,
          "Apodo",
          csv.Membresia
        );
        csv.valido = false;
        if(!mem){
          mem = this.dataMembresias[0]
        }
        if (mem) {
          csv.valido = true;
          csv.idMembresia = mem.Id;
          csv.idCliente = mem.Titular;
          csv.Cliente = mem.TitularName;
        } else {
          let membyid = this.$pgsHelper.getById(
            this.dataMembresias,
            "Id",
            csv.idMembresia
          );
          if (membyid) {
            csv.valido = true;
            csv.idMembresia = mem.Id;
            csv.idCliente = mem.Titular;
            csv.Cliente = mem.TitularName;
          }
        }

        let con = this.$pgsHelper.getById(this.conceptos, "code", csv.Concepto);

        if (con) {
          csv.coceptoId = con.id;
          csv.conceptoDescr = con.dscr;
          csv.category = con.ctgr;
        } else {
          csv.valido = false;
        }

        data.push(csv);
      });
      return data;
    },
  },
  beforeMount: function () {},
  mounted: function () {
    this.getConceptos();
  },
};
</script>




